






























import Vue, { PropType } from "vue";
import { EmployeeDealsResponse } from "@/api/dto/Deal"

export default Vue.extend({
  name: 'CorporateTopDeals',
  props: {
    current: String,
    deals: Array as PropType<EmployeeDealsResponse[]>,
  },
  computed: {
  },
  data() {
    return {
      accordionToggleFlag: true,
    }
  },
  methods: {
    accordionToggle() {
      this.accordionToggleFlag = this.accordionToggleFlag == true ? false : true;
    },
  }
})
